import type { CustomShadows } from './types';

const shadows: CustomShadows = [
  'none',
  '0px 1px 2px 0px rgba(0, 0, 0, 0.24), 0px 1px 2px 0px rgba(0, 0, 0, 0.12), 0px 0px 1px 0px rgba(0, 0, 0, 0.16)',
  '0px 1px 8px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.12), 0px 1px 2px 0px rgba(0, 0, 0, 0.16)',
  '0px 1px 12px 0px rgba(0, 0, 0, 0.12), 0px 4px 8px 0px rgba(0, 0, 0, 0.02), 0px 1px 4px 0px rgba(0, 0, 0, 0.01)',
  '0px 1px 12px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px 0px rgba(0, 0, 0, 0.1)',
  '0px 1px 16px 0px rgba(0, 0, 0, 0.12), 0px 6px 12px 0px rgba(0, 0, 0, 0.12), 0px 4px 8px 0px rgba(0, 0, 0, 0.12)',
  '0px 1px 24px 0px rgba(0, 0, 0, 0.12), 0px 8px 16px 0px rgba(0, 0, 0, 0.12), 0px 6px 12px 0px rgba(0, 0, 0, 0.12)',
  '0px 0px 52px 0px rgba(0, 0, 0, 0.16), 0px 0px 28px 0px rgba(0, 0, 0, 0.16), 0px 0px 18px 0px rgba(0, 0, 0, 0.16)',
  '0px 1px 32px 0px rgba(0, 0, 0, 0.12), 0px 12px 24px 0px rgba(0, 0, 0, 0.12), 0px 8px 16px 0px rgba(0, 0, 0, 0.12)',
  '0px 1px 48px 0px rgba(0, 0, 0, 0.12), 0px 16px 32px 0px rgba(0, 0, 0, 0.12), 0px 12px 24px 0px rgba(0, 0, 0, 0.12)',
  '2px 4px 4px 0px rgba(0, 0, 0, 0.1)',
  '-1px 2px 3px 0px rgba(0, 0, 0, 0.15), 0px 1px 1px 0px rgba(0, 0, 0, 0.05)',
  '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
  '0px 3px 6px 0px rgba(0, 0, 0, 0.1)',
  '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
  '0px 5px 10px 0px rgba(0, 0, 0, 0.1)',
  '0px 6px 12px 0px rgba(0, 0, 0, 0.1)',
  '0px 7px 14px 0px rgba(0, 0, 0, 0.1)',
  '0px 8px 16px 0px rgba(0, 0, 0, 0.1)',
  '0px 9px 18px 0px rgba(0, 0, 0, 0.1)',
  '0px 10px 20px 0px rgba(0, 0, 0, 0.1)',
  '0px 11px 22px 0px rgba(0, 0, 0, 0.1)',
  '0px 12px 24px 0px rgba(0, 0, 0, 0.1)',
  '0px 13px 26px 0px rgba(0, 0, 0, 0.1)',
  '0px 14px 28px 0px rgba(0, 0, 0, 0.1)',
];

export default shadows;
